import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'data-elements/enrolments'

const plural = 'requests'
const single = 'request'

const dataElementsEnrolment = new ApiCore({
	index: true,
	findOne: false,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

const statuses = {
	approved: "APPROVED",
	rejected: "REJECTED",
	revoked: "REVOKED"
}

dataElementsEnrolment.update = (status, params) => {
	let endpoint;

	if (status === statuses.approved){
		endpoint = `${url}/approve`
	}

	if (status === statuses.rejected){
		endpoint = `${url}/reject`
	}

	if (status === statuses.revoked){
		endpoint = `${url}/revoke`
	}

	return axios
		.put(`${apiProvider.BASE_URL}/${endpoint}`, params)
		.then(handleResponse)
		.catch(handleError);
}

dataElementsEnrolment.post = (params) => {
	let endpoint = `${url}/remove`;

	return axios
		.post(`${apiProvider.BASE_URL}/${endpoint}`, params)
		.then(handleResponse)
		.catch(handleError);
}

dataElementsEnrolment.remove = (params) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}`, {data: params})
		.then(handleResponse)
		.catch(handleError);
}

dataElementsEnrolment.removePitstop = (enrolmentId) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/` + enrolmentId)
		.then(handleResponse)
		.catch(handleError);
}
dataElementsEnrolment.updateContributer = (params) => {
		let endpoint=`enrolments/updateEnrolment`;
		return axios
			.put(`${apiProvider.BASE_URL}/${endpoint}`, params)
			.then(handleResponse)
			.catch(handleError);
}

export default dataElementsEnrolment
